import React from 'react'
import reactCSS from 'reactcss'

export const ColorPickerPointer = () => {
    const styles = reactCSS({
        'default': {
            picker: {
                width: '1em',
                height: '1.1em',
                borderRadius: '0.5em',
                transform: 'translate(-.5em, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)',
            },
        },
    });

    return (
        <div style={ styles.picker } />
    )
}

export default ColorPickerPointer



// WEBPACK FOOTER //
// ./src/components/recoloring/ColorPickerPointer.js